import Product from './ProductDetailController';

export default Product;
